import "reflect-metadata";
import Vue from 'vue';
import App from './App.vue';
import router from './router/router';
import store from './store';
import BootstrapVue from 'bootstrap-vue';
import VueMaterial from 'vue-material';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-material/dist/vue-material.min.css';
import buildDependencyContainer from './app/core/dependency.container';
import VueRx from 'vue-rx';
import VeeValidate from 'vee-validate';
import VueCookies from 'vue-cookies';
import moment from "moment";

Vue.use(BootstrapVue);
Vue.use(VueMaterial);
Vue.use(VueRx);
Vue.use(VeeValidate);
Vue.use(VueCookies);
Vue.$cookies.config("5d", '', process.env.VUE_APP_BNA_COOKIE_DOMAIN, false);

Vue.filter('twoDecimals', function(value: number){
  if(!value) return '';
  value = Math.round((value + Number.EPSILON) * 100) / 100;
  return value;
});

Vue.filter('dateFormat', function(date: string, format: string, sourceFormat?: string ){
  if(!date) return '';
  if(sourceFormat){
    return moment(date, sourceFormat).format(format);
  }
  return moment(date).format(format);
});
Vue.filter('timeFormat', function(time: string){
  if(!time) return '';
  if(time.length < 4){
    time = (Array(5).join('0') + time).slice(-4)
  }
  if(time.length === 4){
    return time.slice(0, time.length-2) + ':' + time.slice(time.length-2);
  }
  return time;
});

buildDependencyContainer();
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
